export default __webpack_public_path__ + "static/media/rebirth_dark.57e885a5.svg";